import {Component, OnInit, ViewChild} from '@angular/core';

import {environment} from '../environments/environment';
import {Logger} from './shared/utils/logger';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(
    ) {
    }

    ngOnInit() {
        Logger.log('ver:', environment.version);
    }
}
